import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Directive({
  selector: '[hasPermission]',
})
export class HasPermissionDirective implements OnDestroy {
  private permission = '';
  private visible = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService
  ) {}

  @Input()
  set hasPermission(permission: string) {
    this.permission = permission;
    this.updateView();
  }

  ngOnDestroy(): void {
    this.viewContainer.clear();
  }

  private updateView(): void {
    const allowed =
      !!this.permission?.trim() &&
      this.authService.hasPermission(this.permission);
    if (allowed && !this.visible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.visible = true;
    } else if (!allowed && this.visible) {
      this.viewContainer.clear();
      this.visible = false;
    }
  }
}
